/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Retry: 'Retry', // '다시 검색',
        Search: 'Search',        
        MainBot: 'MainBot', // '보고싶은 상품의 카테고리를 선택하시거나, 상품을 직접 검색해보세요.',
        Placeholder: 'Placeholder',// '상품명을 입력해보세요. 예) 치약',
        ResultBotFound: 'ResultBotFound', // '{count}개의 상품을 검색했어요. [상품 더보기]를 누르면 다음 상품 검색결과를 볼 수 있어요.',
        ResultBotNotFound: 'ResultBotNotFound',// '검색결과가 없어요.<br>애터미의 신상품과 인기상품을 보시겠어요?',
        ResultBotNotLogin: 'ResultBotNotLogin', // '{count}개의 상품을 검색했어요. 상품을 담으려면 먼저 로그인을 해야해요.',
        ResultMore: 'ResultMore',
        MoreCategory: 'MoreCategory',
        CategoryResult: 'CategoryResult',// '{count}개의 {$category} 상품이 있어요.',
        LessTwoProduct: 'LessTwoProduct',
        MoreCategoryResult: 'MoreCategoryResult', //상품더보기를 눌렀을때 사용할 결과폼
        NotMiddleResult: 'NotMiddleResult', //중카테고리가 없을때 사용할 결과폼
        NoLoginMoreCategory: 'NoLoginMoreCategory', //비로그인 파파 Bot
        NologinResultBotFound: "NologinResultBotFound",
        BestKeywordSearch: 'BestKeywordSearch', //인기상품 키워드 클릭시의 버블멘트
        PreResult: 'PreResult',// '이전 검색 결과',
        SearchNext: 'SearchNext',// '검색결과 더보기',
        ProductCategoryResult: 'ProductCategoryResult',
        quickPreResult: 'quickPreResult',
    },
    tomy:{
        kr: {
            Search: '상품검색',
            SearchNext: '상품 더보기',
            PreResult: '이전 검색 결과',
            quickPreResult: '이전 검색 결과',
            MainBot: '찾는 상품이 있으신가요? 카테고리를 선택하거나 직접 검색할 수 있습니다.',
            Placeholder: '상품명을 입력해보세요. 예) 치약',
            ResultBotFound: '{count}개의 상품을 검색했습니다. [상품 더보기]를 누르면 다음 상품 보실 수 있어요.',
            ResultBotNotFound: '검색 결과가 없습니다. <br>애터미인에게 가장 인기 있는 상품이나 새로 나온 상품을 보는 건 어떠신가요?',
            ResultBotNotLogin: '{count}개의 상품을 검색했어요. 상품을 담으려면 먼저 로그인을 해야해요.',
            Retry: '다시 검색',
            ResultMore: '검색 결과를 더 보여드리겠습니다.',
            MoreCategory: '상품을 조금 더 자세히 보여드려요.',
            CategoryResult: '{category}상품은 {count}개 있습니다.', //category === 중카테고리.
            ProductCategoryResult: '{category}은 {count}개 있습니다.',
            MoreCategoryResult: '{category} 상품을 더 보여드리겠습니다.', //category === 중카테고리.
            LessTwoProduct: '{count}개의 상품을 검색했어요. [다시 검색]을 누르면 다른 상품을 찾을 수 있습니다.',
            NotMiddleResult: '{count}개의 {category} 상품이 있습니다.', //category === 대카테고리.
            BestKeywordSearch: '{keyword} 검색 결과입니다.',
            NoLoginMoreCategory: '이 상품이 맞나요? 장바구니에 상품을 담으려면 오른쪽 상단에서 [로그인]을 먼저 해주세요.',
            NologinResultBotFound: '검색한 상품은 {count}개가 있네요. 상품을 장바구니에 담으려면 먼저 로그인을 해야 한답니다.',


        },
        eng: {
            Search: 'product search',
            SearchNext: 'Next',
            PreResult: 'Previous',
            quickPreResult: 'Previous search results',
            MainBot: 'Have a product you are looking for? You can select a category or search directly.',
            Placeholder: 'Please enter the product name.',
            ResultBotFound: 'You found {count} products. Click [Next] to view more products.',
            ResultBotNotFound: 'No results were found for your search. How about seeing the most popular or new products from Atomy People?',
            ResultBotNotLogin: 'Is this the correct product for you? To add items to your shopping cart, please log in first in the upper right corner.',
            Retry: 'Product search',
            ResultMore: "We'll show you more search results.",
            MoreCategory: 'Let me show you the product in a little more detail.',
            CategoryResult: 'There are {count} products in {category}.', //category === 중카테고리.
            ProductCategoryResult: 'There are {count} products in {category}.',
            LessTwoProduct: 'You searched for {count} products. You can find other products by clicking [Product search].',
            MoreCategoryResult: 'We will show you more {category} products.', //category === 중카테고리.
            NotMiddleResult: 'There are {count} {category} products.', //category === 대카테고리.
            BestKeywordSearch: 'These are the results of a {keyword} search result.',
            NologinResultBotFound: 'There are {count} products you searched for. To add items to your shopping cart, you must first log in.',

        },    
    },
    papa:{
        kr: {
            Search: '상품검색',
            PreResult: '이전 검색 결과',
            SearchNext: '상품 더보기',
            MainBot: '어떤 상품을 찾나요?',
            quickPreResult: '이전 검색 결과',
            Placeholder: '상품명을 입력해보세요. 예) 치약',
            ResultBotFound: '검색한 상품은 {count}개가 있네요.<br> [상품 더보기]를 누르면 다음 상품을 볼 수 있어요.',
            NologinResultBotFound: '검색한 상품은 {count}개가 있네요. 상품을 장바구니에 담으려면 먼저 로그인을 해야 한답니다.',
            ResultBotNotFound: '이런, 찾는 상품이 없네요. 대신 애터미 신상품이나 인기상품은 뭐가 있는지 둘러보는 것도 좋겠어요.',
            ResultBotNotLogin: '{count}개의 상품을 검색했어요. 상품을 담으려면 먼저 로그인을 해야해요.',
            Retry: '다시 검색',
            ResultMore: '검색 결과를 더 볼 수 있어요.',
            MoreCategory: '이 상품을 찾나요?',
            NoLoginMoreCategory: '이 상품이 맞나요? 장바구니에 상품을 담으려면 오른쪽 상단에서 [로그인]을 먼저 해주세요.',
            CategoryResult: '총 {count}개의 {category} 상품이 있어요.', //category === 중카테고리.
            ProductCategoryResult: '총 {count}개의 {category}이 있어요.',
            LessTwoProduct: '검색한 상품은 {count}개가 있네요. 다른 상품을 검색하려면 아래 [다시 검색]을 누르세요.',
            MoreCategoryResult: '{category} 상품이 더 준비되어 있어요.', //category === 중카테고리.
            NotMiddleResult: '총 {count}개의 {category} 상품이 있어요.', //category === 대카테고리.
            BestKeywordSearch: '{keyword} 상품이 {num}개 있네요. 요즘 정말 많이들 찾던데요.',
        },
        eng: {
            Search: 'product search',
            PreResult: 'Previous',
            SearchNext: 'Next',
            quickPreResult: 'Previous search results',
            MainBot: 'What products are you looking for?',
            Placeholder: 'Please enter the product name.',
            ResultBotFound: 'There are {count} products you searched for. Click [Next] to view the following products.',
            NologinResultBotFound: 'There are {count} products you searched for. To add items to your shopping cart, you must first log in.',
            ResultBotNotFound: "Oh, I can't find the product I'm looking for. Instead, it would be a good idea to look around Atomy's new and popular products.",
            ResultBotNotLogin: 'Is this the correct product for you? To add items to your shopping cart, please log in first in the upper right corner.',
            Retry: 'Product search',
            ResultMore: 'You can see more search results.',
            MoreCategory: 'Are you looking for this product?',
            NoLoginMoreCategory: 'Is this product right for you? To add items to your shopping cart, please log in first in the upper right corner.',
            CategoryResult: 'There are a total of {count} {category} products.', //category === 중카테고리.
            ProductCategoryResult: 'There are {count} products in {category}.',
            LessTwoProduct: 'There are {count} products you searched for. To search for other products, click [Product search] below.',
            MoreCategoryResult: 'There are more {category} products available.', //category === 중카테고리.
            NotMiddleResult: 'There are a total of {count} {category} products.', //category === 대카테고리.
        },
    },
};
